import React from "react";

function Profil() {
    return (
        <div className="profil mb5">
        <h2 className="h2">Profil</h2>
        <p>
            Étudiant en 5ème année à l'ÉSTIAM sur le campus de Tarbes, je suis actuellement en contrat d'apprentissage au sein 
            de l'entreprise <strong>Safran Helicopter Engines</strong> à Bordes dans les Pyrénées-Atlantiques. 
        </p>
        </div>
    )
}

export default Profil